import Component from 'can/component/component';
import template from './modal-ie-warning.stache';
import deviceUtil from 'scripts/utils/device';
import $ from 'jquery';

Component.extend({
    tag: 'modal-ie-warning',
    template: template,
    viewModel: {
        title: globalSettings.messages.ieMessage.title,
        text: globalSettings.messages.ieMessage.text,
        browsers: globalSettings.messages.ieMessage.browsers,
        caption: globalSettings.messages.ieMessage.caption
    },
    events: {
        inserted() {
            this.viewModel.attr('isOldIE', !!deviceUtil.isIE() && !deviceUtil.isEdgeIE);
            $('.s-modal-text.s-ie-text-warning').prepend(this.viewModel.text);
        },
        '.s-btn-close click': function () {
            $('.c-modal-ie-dialog').hide();
        }
    }
});
